export const deferredWarmupMappings = {
    sia: {
        apiUrl: '/api/secure/account-maintenance/v1/users/warmup'
    }
};
